import React from 'react';
import styles from './Tooltip.module.css';

export type TooltipPlacement = 'top' | 'bottom';

export interface TooltipProps {
  content?: string | null;
  placement?: TooltipPlacement;
  className?: string;
  children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  placement = 'top',
  className = '',
  children,
}) => {
  const trimmed = typeof content === 'string' ? content.trim() : '';

  if (!trimmed) {
    return <>{children}</>;
  }

  return (
    <span
      className={[
        styles.tooltip,
        placement === 'bottom' ? styles.bottom : styles.top,
        className,
      ].filter(Boolean).join(' ')}
      data-tooltip={trimmed}
    >
      {children}
    </span>
  );
};

export default Tooltip;
